import * as React from 'react';

// import {Link} from 'shells/link/link';
import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {HelpModal} from 'shells/modal/help-modal';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {ModalBody} from 'shells/typography/modal-body';
import {ModalHeader} from 'shells/typography/modal-header';

import {MessageModalGraphic} from './assets/message-modal-graphic';

import styles from './tooltip-modal-styles.module.css';

type Props = {
    isOpen: boolean;
    onClose: () => void;
};

export function MessageBounceModal(props: Props) {
    return (
        <HelpModal
            isOpen={props.isOpen}
            onClose={props.onClose}
            artImage={<MessageModalGraphic />}
            bodyComponent={
                <div className={styles.container}>
                    <ModalHeader>Bounce rate</ModalHeader>
                    <SpacerGroup mb={32}>
                        <SpacerGroup mb={16}>
                            <ModalBody>
                                <b>Bounce rate</b> represents the percentage of messages that could
                                not be delivered. This bounce rate is calculated for hard bounces
                                only.
                            </ModalBody>
                        </SpacerGroup>
                    </SpacerGroup>
                    <BulletedList
                        bullets={[
                            <ModalBody key='1'>
                                <SpacerGroup mb={8}>
                                    <b>Hard bounces</b> occur when an email cannot be delivered due
                                    to permanent reasons, like an invalid email address or a blocked
                                    server
                                </SpacerGroup>
                                <i>
                                    Nutshell will never send messages to contacts that have hard
                                    bounced
                                </i>
                            </ModalBody>,
                            <ModalBody key='2'>
                                <SpacerGroup mb={8}>
                                    <b>Soft bounces</b> occur when an email cannot be delivered due
                                    to temporary reasons, like an out of office response or a full
                                    inbox
                                </SpacerGroup>
                                <i>
                                    Nutshell will continue sending messages to contacts that have
                                    soft bounced
                                </i>
                            </ModalBody>,
                        ]}
                    />
                    {/* Uncomment & add correct link when article is published
                    <SpacerGroup mb={32}>
                        <ModalBody>
                            Learn more about{' '}
                            <Link href='https://support.nutshell.com'>bounce rates</Link> in our
                            knowledge base.
                        </ModalBody>
                    </SpacerGroup> */}
                </div>
            }
        />
    );
}
